export const formatDisplayLabel = (snakeCase) => {
  if (!snakeCase) return '';

  // Define your label mappings - easy to update
  const labelMap = {
    // Measures
    impressions: 'Impressions',
    clicks: 'Clicks',
    installs: 'Installs',
    kpi_event_count: 'KPI Event Count',
    media_cost: 'Media Cost',
    // raw_attributed_events: 'Raw Attributed Events',
    mmp_nstalls: 'MMP Installs',
    skan_nstalls: 'SKAN Installs',
    mmp_events: 'MMP Events',
    skan_events: 'SKAN Events',
    ctr: 'CTR',
    ecpc: 'ECPC',
    ecpm: 'ECPM',
    ecpe: 'ECPE',
    ecpi: 'ECPI',
    mmp_ecpi: 'MMP ECPI',
    mmp_ecpe: 'MMP ECPE',
    skan_ecpi: 'SKAN ECPI',
    skan_ecpe: 'SKAN ECPE',

    // Metrics
    campaign_guid: 'Campaign ID',
    campaign_name: 'Campaign Name',
    country: 'Country',
    os: 'OS',
    app_bundle: 'App Bundle',
    exchange_name: 'Exchange Name',
    event_name: 'Event Name',
    creative_guid: 'Creative ID',
    creative_name: 'Creative Name',
    creative_type: 'Creative Type'
  };

  // Return mapped label or auto-format if not found
  return labelMap[snakeCase] || autoFormat(snakeCase);
};

// Fallback auto-formatter for unmapped items
const autoFormat = (snakeCase) => {
  return snakeCase
    .split('_')
    .map((word) => {
      // Handle special cases
      if (word.toLowerCase() === 'os') return 'OS';
      if (word.toLowerCase() === 'mmp') return 'MMP';
      if (word.toLowerCase() === 'skan') return 'SKAN';
      if (word.toLowerCase() === 'kpi') return 'KPI';
      if (word.toLowerCase() === 'ctr') return 'CTR';

      // Default capitalization
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

// Convert array of strings to {value, label} objects
export const formatOptions = (items) => {
  if (!Array.isArray(items)) return [];

  return items.map((item) => ({
    value: item,
    label: formatDisplayLabel(item)
  }));
};

// Get label for a specific value
export const getLabel = (value, options) => {
  const option = options.find((opt) => opt.value === value);
  return option ? option.label : formatDisplayLabel(value);
};
